import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-643c4eab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "mt5" }
const _hoisted_4 = { class: "mt5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {"color":"#909399"},
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "鲁ICP备2020038011号-1", -1))

import {useRouter} from "vue-router";
import {reactive} from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const router = useRouter()

const data = reactive({
    urlList: [
        {id: 1, name: '社区公约', path: '/legal/community_guidelines'},
        {id: 2, name: '隐私政策', path: '/legal/privacy'},
        {id: 3, name: '用户服务协议', path: '/legal/terms'},
        // {id: 4, name: '关于我们', path: '/about'},
    ]
})
const toTarget = (target: string) => {
    router.push({path: target})
}

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_space = _resolveComponent("el-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_space, { spacer: " / " }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.urlList, (item) => {
            return (_openBlock(), _createBlock(_component_el_text, {
              key: item.id,
              class: "cu-pointer",
              type: "info",
              onClick: ($event: any) => (toTarget(item.path))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_text, { type: "info" }, {
          default: _withCtx(() => [
            _createTextVNode(" 黑鸭社区「wiung.com」，始于2018.10，由众多踩坑从业者维护，致力于企业评分，仅作为求职者的一份参考。 本站为非盈利性站点，所有内容不作为商业行为。不得将本站内容用于商业或者非法用途，否则，一切后果请用户自负。 ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_text, { type: "info" }, {
          default: _withCtx(() => [
            _createTextVNode("Copyright © 2023 黑鸭社区 - "),
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})